export default {
  getAuth: state => {
    return state.authenticated
  },
  getUri: state => {
    return state.apiuri
  },
  getTestUri: state => {
    return state.testuri
  },
  getHot: state => {
    return state.hot
  },
  getArticle: state => {
    return state.article
  },
  getSlide: state => {
    return state.slide
  },
  getSongCategory: state => {
    return state.songCategory
  },
  getActivity: state => {
    return state.activity
  },
  getSongTagLang: state => {
    return state.songTagLang
  },
  getSongTagTempo: state => {
    return state.songTagTempo
  },
  getSongLatest: state => {
    return state.songLatest
  },
  getSongSpecial: state => {
    return state.songSpecial
  },
  getSongShare: state => {
    return state.songShare
  },
  getPartnerCategory: state => {
    return state.partnerCategory
  },
  getUserID: state => {
    return state.userId
  },
  getUserName: state => {
    return state.userName
  },
  getUserEmail: state => {
    return state.userEmail
  },
  getToken: state => {
    return state.token
  }
}



// WEBPACK FOOTER //
// ./src/store/home/getters.js